import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'
import { AuthorizeService } from './auth.service'

export default class HttpClient {
  public instance: AxiosInstance

  public constructor(baseURL: string) {
    this.instance = axios.create({
      baseURL
    })
    this._initializeRequestInterceptor()
  }

  private _initializeRequestInterceptor = () => {
    this.instance.interceptors.request.use(
      this._handleRequest,
      this._handleError
    )
  }
  private _handleRequest = async (config: AxiosRequestConfig) => {
    const auth = new AuthorizeService()
    const isAuth = await auth.isAuthenticated()

    if (!isAuth) await auth.signIn('')

    const token = await auth.getIdToken()
    if (!!token && this.isSameOriginUrl(config)) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  }

  protected _handleError = (error: any) => Promise.reject(error)

  private isSameOriginUrl(req: any) {
    // It's an absolute url with the same origin.
    if (req.url.startsWith(`${window.location.origin}/`)) {
      return true
    }

    // It's a protocol relative url with the same origin.
    // For example: //www.example.com/api/Products
    if (req.url.startsWith(`//${window.location.host}/`)) {
      return true
    }

    // It's a relative url like /api/Products
    if (/^\/[^\/].*/.test(req.url)) {
      return true
    }

    // It's an absolute or protocol relative url that
    // doesn't have the same origin.
    return false
  }
}
